import { render, staticRenderFns } from "./configuration-instrumentation-devices-modal-notifications-form.vue?vue&type=template&id=5e0d4509&scoped=true&"
import script from "./configuration-instrumentation-devices-modal-notifications-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-instrumentation-devices-modal-notifications-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-instrumentation-devices-modal-notifications-form.scss?vue&type=style&index=0&id=5e0d4509&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d4509",
  null
  
)

export default component.exports